(function () {
  function loadCountdownTimers() {
    const countdownTimers = document.querySelectorAll('.countdown-event-timer');

    countdownTimers.forEach((timer) => {
      const saleEndDate = timer.getAttribute('data-end-date');
      const endTime = new Date(saleEndDate).getTime();

      const daysSpan = timer.querySelector('.days');
      const hoursSpan = timer.querySelector('.hours');
      const minutesSpan = timer.querySelector('.minutes');
      const secondsSpan = timer.querySelector('.seconds');

      const updateCountdown = () => {
        const now = new Date().getTime();
        const timeLeft = endTime - now;

        if (timeLeft <= 0) {
          daysSpan.textContent = '00';
          hoursSpan.textContent = '00';
          minutesSpan.textContent = '00';
          secondsSpan.textContent = '00';
          clearInterval(interval);
          return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        daysSpan.textContent = days.toString();
        hoursSpan.textContent = hours.toString();
        minutesSpan.textContent = minutes.toString();
        secondsSpan.textContent = seconds.toString();
      };

      updateCountdown();
      const interval = setInterval(updateCountdown, 1000);
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('cartUpdated', loadCountdownTimers);
    loadCountdownTimers();
  });
})();
